import React, { useState } from 'react';
import './EditSidebar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FaInfoCircle } from 'react-icons/fa';
import ProductDropdown from '../CreateSidebar/ProductDropdown';
import ProductGallery from '../ProductsAndStyle/ProductGallery';
import { USER_NAME } from '../../../constant';
import { useImage } from '../../../context/ImageContext';
import { downloadImage, sendToBackend } from '../../../utils/utilities';
import { uploadToS3 } from '../../../config/aws';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { checkAvailableCredits } from '../../../dbApiFunctions';
import { showSuccessAlert, showErrorAlert, showWarningAlert, showInfoAlert, showConfirmDialog } from '../../../utils/sweetAlertConfig';
import '../../../styles/sweetAlert.css';
import CreativeControl from '../CreateSidebar/CreativeControl';
import { repharsePrompt } from '../../../services/chatgptService';

const EditSidebar = ({ editUploadedImages, setEditUploadedImages, brushSize, setBrushSize, eraserSize, setEraserSize, activeButton, setActiveButton, editEstTime, setEditEstTime, setJobResponseEdit, progressEdit, setCreditsAvailable, setSelectedEditGroup, selectedAction, setSelectedAction, selectedProduct, setSelectedProduct, inputValue, setInputValue, accessoryImage, setAccessoryImage, prompt, setPrompt, loadingCircle, setLoadingCircle, refNum, setRefNum, numberOfImages, setNumberOfImages, options }) => {
    const { imageCanvasRef, drawCanvasRef } = useImage();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [addFeatures, setAddFeatures] = useState(true);
    const [isProductModalOpen, setIsProductModalOpen] = useState(false);
    const [randomize, setRandomize] = useState(true);
    const [showRandomizeInfo, setShowRandomizeInfo] = useState(false);
    const [showAreaInfo, setShowAreaInfo] = useState(false);
    const [showActOnAreaInfo, setShowActOnAreaInfo] = useState(false);
    const [creativeControlValue, setCreativeControlValue] = useState(0);
    const [isRephrasing, setIsRephrasing] = useState(false);

    const handleSelectAction = (action) => {
        setSelectedAction(action);
        if (action === 'add') {
            setAddFeatures(true);
        } else {
            setAddFeatures(false);
        }
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setEditUploadedImages([{ src: e.target.result }]);
                setSelectedEditGroup([{ src: e.target.result }]);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAccessoryUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setAccessoryImage(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
    };

    const handleGenerate = async () => {
        setLoadingCircle(true);
        try {
            const timestamp = new Date().getTime();
            const base_path = `USERS/${USER_NAME}/all_editPage/${timestamp}/inputFolder/`;

            if (selectedAction === 'add' && (!selectedProduct || selectedProduct.name === "Select a Product Image") && (!accessoryImage) && (!prompt.trim())) {
                // alert("Please select a product image or add Accessory Image or Enter a Prompt");

                showErrorAlert('Please select a product image or add Accessory Image or Enter a Prompt', 'Missing Information');
                return;
            }
            // setEditEstTime(120);

            // Check if the selected action is 'add'            
            if (selectedAction === 'add') {
                if (accessoryImage) {
                    // console.log('Uploading accessory image...');
                    try {
                        // Convert base64 image to blob for upload
                        const base64Response = await fetch(accessoryImage);
                        const blob = await base64Response.blob();
                        await uploadToS3(base_path + 'accessory.png', blob.type, blob);
                        // console.log('Accessory image uploaded successfully');
                    } catch (error) {
                        console.error('Error uploading accessory image:', error);
                    }
                }

                if (selectedProduct && selectedProduct.name !== "Select a Product Image") {
                    // console.log('Uploading product image...');
                    try {
                        // If the product image is a URL, fetch it and upload it
                        const productResponse = await fetch(selectedProduct.src, {
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: {
                                'Access-Control-Allow-Origin': '*'
                            }
                        });

                        if (!productResponse.ok) {
                            throw new Error(`Failed to fetch product image: ${productResponse.status} ${productResponse.statusText}`);
                        }

                        const productBlob = await productResponse.blob();
                        await uploadToS3(base_path + 'product.png', productBlob.type || 'image/png', productBlob);
                        // console.log('Product image uploaded successfully');
                    } catch (error) {
                        console.error('Error uploading product image:', error);
                        // Try an alternative approach with Image object
                        try {
                            // console.log('Trying alternative method-2 to fetch product image');
                            const img = new Image();
                            img.crossOrigin = 'Anonymous';

                            // Create a promise to wait for the image to load
                            await new Promise((resolve, reject) => {
                                img.onload = resolve;
                                img.onerror = reject;
                                img.src = selectedProduct.src;
                            });

                            // Create a canvas to draw the image and get the data
                            const canvas = document.createElement('canvas');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0);

                            // Convert canvas to blob
                            const canvasBlob = await new Promise(resolve => {
                                canvas.toBlob(blob => resolve(blob), 'image/png');
                            });

                            await uploadToS3(base_path + 'product.png', 'image/png', canvasBlob);
                            // console.log('Product image uploaded using alternative method-2');
                        } catch (altError) {
                            console.error('Alternative method-2 also failed:', altError);
                        }
                    }
                }

                // if (!prompt.trim()) {
                //     alert("Please enter a prompt description");
                //     return;
                // }
            }

            // Upload the masked image (if available)
            if (drawCanvasRef && drawCanvasRef.current) {
                // console.log('Uploading mask image...');
                try {
                    const drawCanvas = drawCanvasRef.current;
                    // Convert canvas to blob
                    const maskBlob = await new Promise(resolve => {
                        drawCanvas.toBlob(blob => {
                            resolve(blob);
                        }, 'image/png');
                    });

                    if (maskBlob) {
                        await uploadToS3(base_path + 'mask.png', 'image/png', maskBlob);
                        // console.log('Mask image uploaded successfully');
                    } else {
                        // console.log('Mask blob is null or empty');
                    }
                } catch (error) {
                    console.error('Error uploading mask image:', error);
                }
            }

            // Upload the main image if available
            if (editUploadedImages && editUploadedImages.length > 0 && editUploadedImages[0].src) {
                // console.log('Uploading main input image...');

                try {
                    // For data URLs, use direct base64 conversion
                    if (editUploadedImages[0].src.startsWith('data:')) {
                        // console.log('Input image is a data URL, processing directly');
                        try {
                            const base64Data = editUploadedImages[0].src.split(',')[1];
                            const binaryData = atob(base64Data);
                            const arrayBuffer = new ArrayBuffer(binaryData.length);
                            const uint8Array = new Uint8Array(arrayBuffer);

                            for (let i = 0; i < binaryData.length; i++) {
                                uint8Array[i] = binaryData.charCodeAt(i);
                            }

                            const blob = new Blob([arrayBuffer], { type: 'image/png' });
                            await uploadToS3(base_path + 'original.png', 'image/png', blob);
                            // console.log('Input image uploaded successfully from data URL');
                        } catch (dataUrlError) {
                            console.error('Error processing data URL:', dataUrlError);
                        }
                    } else {
                        // Try to fetch the URL
                        const imgResponse = await fetch(editUploadedImages[0].src, {
                            mode: 'cors',
                            cache: 'no-cache',
                            headers: {
                                'Access-Control-Allow-Origin': '*'
                            }
                        });

                        if (!imgResponse.ok) {
                            throw new Error(`Failed to fetch input image: ${imgResponse.status} ${imgResponse.statusText}`);
                        }

                        const imgBlob = await imgResponse.blob();
                        await uploadToS3(base_path + 'original.png', imgBlob.type || 'image/png', imgBlob);
                        // console.log('Input image uploaded successfully');
                    }
                } catch (error) {
                    console.error('Error uploading input image:', error);

                    // Try with Canvas approach
                    try {
                        // console.log('Trying to upload input image using canvas approach');
                        const img = new Image();
                        img.crossOrigin = 'Anonymous';

                        // Create a promise to wait for the image to load
                        await new Promise((resolve, reject) => {
                            img.onload = resolve;
                            img.onerror = reject;
                            if (editUploadedImages[0].src.startsWith('data:')) {
                                img.src = editUploadedImages[0].src;
                            } else {
                                // Add cache buster for external URLs
                                img.src = `${editUploadedImages[0].src}${editUploadedImages[0].src.includes('?') ? '&' : '?'}t=${Date.now()}`;
                            }
                        });

                        // Create a canvas to draw the image and get the data
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);

                        // Try direct upload of canvas blob
                        const canvasBlob = await new Promise(resolve => {
                            canvas.toBlob(blob => resolve(blob), 'image/png');
                        });

                        await uploadToS3(base_path + 'original.png', 'image/png', canvasBlob);
                        // console.log('Input image uploaded using canvas method');
                    } catch (canvasError) {
                        console.error('Canvas method also failed:', canvasError);

                        // Last resort - try to take a screenshot of the image element
                        try {
                            // console.log('Attempting final fallback method');
                            // Find the actual image element in the DOM
                            const imgElement = document.querySelector('.image-section img');
                            if (imgElement) {
                                // console.log('Found image element in DOM, capturing it');

                                // Create a new canvas with the exact dimensions of the image
                                const finalCanvas = document.createElement('canvas');
                                finalCanvas.width = imgElement.naturalWidth || imgElement.width;
                                finalCanvas.height = imgElement.naturalHeight || imgElement.height;

                                // Draw the image onto the canvas
                                const finalCtx = finalCanvas.getContext('2d');
                                finalCtx.drawImage(imgElement, 0, 0, finalCanvas.width, finalCanvas.height);

                                // Get the canvas data as a blob
                                const finalBlob = await new Promise(resolve => {
                                    finalCanvas.toBlob(blob => resolve(blob), 'image/png', 1.0);
                                });

                                await uploadToS3(base_path + 'original.png', 'image/png', finalBlob);
                                // console.log('Input image uploaded using DOM element capture');
                            } else {
                                console.error('Could not find image element in DOM');
                            }
                        } catch (finalError) {
                            console.error('All methods failed to upload input image:', finalError);
                        }
                    }
                }
            }

            // Upload metadata
            const metadata = {
                productName: selectedProduct.name === "Select a Product Image" ? null : selectedProduct.name,
                prompt: prompt,
                totalImages: numberOfImages,
                accessoryImage: accessoryImage ? true : false,
                timestamp: timestamp,
                userName: USER_NAME,
                act_on_area: selectedAction,
                randomize: randomize,
                creativeControl: options[creativeControlValue].label,
                creativeControlValue: creativeControlValue,
                time: new Date().toLocaleString('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    month: 'short',
                    day: 'numeric',
                    hour12: false
                })
            };

            try {
                // console.log('Uploading metadata:', metadata);
                await uploadToS3(`USERS/${USER_NAME}/all_editPage/${timestamp}/metadata.json`, 'application/json', JSON.stringify(metadata));
                // console.log('Metadata uploaded successfully');
            } catch (error) {
                console.error('Error uploading metadata:', error);
            }

            // console.log('Generating with:', metadata);

            // Send data to backend for processing
            try {

                // for (let i = 0; i < numberOfImages-1; i++) {
                //     metadata['pid'] = i;
                //     const response = sendToBackend('edit', metadata, numberOfImages);
                // }
                const password = sessionStorage.getItem("password");
                const email = sessionStorage.getItem("email");
                const creditsAvailable = await checkAvailableCredits(email, password, numberOfImages);
                if (!creditsAvailable.status) {
                    // alert(creditsAvailable.message);

                    showErrorAlert(creditsAvailable.message, 'Insufficient Credits');
                    return;
                }
                const backendPromises = [];
                if (numberOfImages > 1) {
                    const metadata2 = structuredClone(metadata);
                    metadata2['pid'] = numberOfImages - 2;
                    backendPromises.push(sendToBackend('edit', metadata2, 0, setCreditsAvailable));
                }

                if (numberOfImages > 2) {
                    const metadata3 = structuredClone(metadata);
                    metadata3['pid'] = numberOfImages - 3;
                    backendPromises.push(sendToBackend('edit', metadata3, 0, setCreditsAvailable));
                }

                if (numberOfImages > 3) {
                    const metadata4 = structuredClone(metadata);
                    metadata4['pid'] = numberOfImages - 4;
                    backendPromises.push(sendToBackend('edit', metadata4, 0, setCreditsAvailable));
                }

                metadata['pid'] = numberOfImages - 1;
                backendPromises.push(sendToBackend('edit', metadata, numberOfImages, setCreditsAvailable));

                // Wait for all backend calls to complete
                const responses = await Promise.all(backendPromises);

                const response = responses[responses.length - 1]; // Get the last response

                // console.log("Edit response is=", response);
                // console.log('Data sent to backend successfully');
                setJobResponseEdit(response);
                // setEditEstTime(response.est_time);
                if (response && response.hasOwnProperty('est_time')) {
                    // console.log("Edit waiting time is=", response.est_time);
                } else {
                    // console.log("Edit waiting time is not available");
                }
            } catch (error) {
                console.error("Error in handleGenerate:", error);
                // alert("Failed to generate images. Please try again.");

                showErrorAlert("Failed to generate images. Please try again.")
            }

        } catch (error) {
            console.error('Error in handleGenerate:', error);
            // alert('There was an error processing the images. Please try again.');


            showErrorAlert("There was an error processing the images. Please try again.");

        } finally {
            setEditEstTime(1);
        }
        setLoadingCircle(false);
    };

    return (
        <div className="edit-sidebar overflow-y-auto h-full pb-24" style={{ maxHeight: '70vh' }}>
            {/* Image Section */}
            <div className="image-section">
                <img
                    src={editUploadedImages[0]?.src}
                    style={{ filter: "blur(1.5px)" }}
                    alt="Uploaded image"
                />
                <div className="overlay">
                    <label htmlFor="image-upload" className="upload-label">
                        <i className="fas fa-plus icon" />
                        <input
                            id="image-upload"
                            type="file"
                            accept="image/*"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                        />
                    </label>
                </div>
            </div>

            {/* Area Section */}
            <div className="section" style={{ marginBottom: 0 }}>
                <div className="area-header" >
                    <div className="flex items-center gap-2">
                        <label className="block text-gray-700 font-semibold text-sm tracking-wide">Brush Size</label>
                        <button
                            onClick={() => setShowAreaInfo(!showAreaInfo)}
                            className="text-gray-400 hover:text-purple-500 transition-all duration-300 transform hover:scale-110"
                        >
                            <FaInfoCircle size={16} />
                        </button>
                    </div>
                    <div className="icon-buttons" >
                        <button
                            onClick={() => { setActiveButton('pen'); setInputValue(brushSize); }}
                            className={activeButton === 'pen' ? 'selected' : ''}
                        >
                            <i className="fas fa-pen" />
                        </button>
                        <button
                            onClick={() => { setActiveButton('eraser'); setInputValue(eraserSize); }}
                            className={activeButton === 'eraser' ? 'selected' : ''}
                        >
                            <i className="fas fa-eraser" />
                        </button>
                    </div>
                </div>

                {showAreaInfo && (
                    <div className="mb-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                        <div className="flex items-start space-x-3">
                            <i className="fas fa-lightbulb text-purple-500 mt-0.5"></i>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                Control the brush size for adding or erasing mask
                            </p>
                        </div>
                    </div>
                )}

                <div className="area-controls">
                    <input
                        type="range"
                        min="0"
                        max="50"
                        value={inputValue}
                        onChange={(e) => {
                            setInputValue(parseInt(e.target.value));
                            if (activeButton === 'pen') {
                                setBrushSize(parseInt(e.target.value));
                            } else {
                                setEraserSize(parseInt(e.target.value));
                            }
                        }}
                    />
                    <div className="icon-buttons" style={{ width: "50px", height: "60px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <button style={{ width: `${inputValue}px`, height: `${inputValue}px`, backgroundColor: '#c9c2fa' }}></button>
                    </div>
                </div>


            </div>

            {/* Act on Area Section */}
            <div className="section">
                <div className="flex items-center gap-2 mb-2">
                    <label className="block text-gray-700 font-semibold text-sm tracking-wide">Task</label>
                    <button
                        onClick={() => setShowActOnAreaInfo(!showActOnAreaInfo)}
                        className="text-gray-400 hover:text-purple-500 transition-all duration-300 transform hover:scale-110"
                    >
                        <FaInfoCircle size={16} />
                    </button>
                </div>

                {showActOnAreaInfo && (
                    <div className="mb-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                        <div className="flex items-start space-x-3">
                            <i className="fas fa-lightbulb text-purple-500"></i>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                Select "Add" to imagine new content in the masked region, or select "Remove" to remove the content in the masked region.
                            </p>
                        </div>
                    </div>
                )}

                <div className="action-buttons">
                    <button
                        className={selectedAction === 'add' ? 'selected' : ''}
                        onClick={() => handleSelectAction('add')}
                    >
                        Add
                    </button>
                    <button
                        className={selectedAction === 'remove' ? 'selected' : ''}
                        onClick={() => handleSelectAction('remove')}
                    >
                        Remove
                    </button>
                </div>
            </div>

            {/* Creative Control Section */}
            {addFeatures && (
                <div className="section">
                    <CreativeControl value={creativeControlValue} setValue={setCreativeControlValue} options={options} />
                </div>
            )}

            {
                addFeatures && (
                    <>
                        {/* Add Product Section */}
                        <div className="section">
                            <ProductDropdown
                                selectedProduct={selectedProduct}
                                setIsProductModalOpen={setIsProductModalOpen}
                                setSelectedProduct={setSelectedProduct}
                            />
                        </div>

                        {/* Add Accessory Section */}
                        <div className="section upload-section">
                            <label className="block text-gray-700 font-semibold text-sm tracking-wide">Add Accessory</label>
                            <div className="upload-box relative">
                                {!accessoryImage ? (
                                    <>
                                        <i className="fas fa-cloud-upload-alt" />
                                        <p>Upload an Image</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleAccessoryUpload}
                                        />
                                    </>
                                ) : (
                                    <div className="relative">
                                        <img src={accessoryImage} alt="Uploaded" />
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setAccessoryImage(null);
                                            }}
                                            className="absolute top-2 right-2 bg-white rounded-full p-1 text-gray-400 hover:text-red-500 transition-all duration-300 shadow-md"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>


                        {/* Prompt Section */}
                        {creativeControlValue === 0 && (
                            <div className="section mb-4" >
                                <label className="block text-gray-700 font-semibold text-sm tracking-wide mb-2">Prompt</label>
                                <div className="relative">
                                    <textarea
                                        className={`w-full p-4 border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 ${isRephrasing ? 'opacity-70' : ''}`}
                                        placeholder="Create a stunning product image featuring a sleek smartwatch, illuminated by soft, ambient lighting that highlights its modern design and vibrant display."
                                        rows="4"
                                        value={prompt}
                                        onChange={(e) => setPrompt(e.target.value)}
                                        disabled={isRephrasing}
                                    ></textarea>
                                    {isRephrasing && (
                                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 rounded-lg">
                                            <div className="flex items-center space-x-2">
                                                <div className="w-3 h-3 bg-[#4B3BFF] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                                                <div className="w-3 h-3 bg-[#4B3BFF] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                                                <div className="w-3 h-3 bg-[#4B3BFF] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="absolute bottom-3 right-3">
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                repharsePrompt(prompt, setPrompt, setIsRephrasing);
                                            }}
                                            className={`p-2 rounded-full hover:bg-gray-100 transition-all duration-300 group cursor-pointer ${isRephrasing ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            title="Rephrase prompt"
                                            disabled={isRephrasing}
                                        >
                                            <FontAwesomeIcon
                                                icon={faWandMagicSparkles}
                                                className={`text-gray-600 group-hover:text-[#4B3BFF] transition-colors duration-300 ${isRephrasing ? 'animate-spin' : ''}`}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                        }

                        {/* <div >                         
                            <div className="flex items-center justify-between p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 bg-white border border-gray-100 group relative overflow-hidden"
                                onClick={() => setRandomize(!randomize)}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-[#4B3BFF] to-[#7B6BFF] opacity-0 group-hover:opacity-5 transition-all duration-300"></div>
                                <label
                                    htmlFor="randomize"
                                    className="text-sm font-medium text-gray-700 cursor-pointer group-hover:text-[#4B3BFF] transition-colors duration-300 flex items-center"
                                    
                                >
                                    <span className="font-bold text-base" >Diversify</span>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowRandomizeInfo(!showRandomizeInfo);
                                        }}
                                        className="text-gray-400 hover:text-[#4B3BFF] transition-all duration-300 transform hover:scale-110 ml-2"
                                    >
                                        <FaInfoCircle size={16} />
                                    </button>
                                </label>
                                <input
                                    type="checkbox"
                                    id="randomize"
                                    className="z-10 w-5 h-5 text-[#4B3BFF] border-gray-300 rounded focus:ring-[#4B3BFF] focus:ring-2 cursor-pointer"
                                    checked={randomize}
                                />
                            </div>
                            {showRandomizeInfo && (
                                <div className="mb-4 mt-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                                    <div className="flex items-start space-x-3">
                                        <i className="fas fa-lightbulb text-purple-500 mt-0.5"></i>
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            Without "Diversify", you'll get the very similar images each time. Turn it on for new variations.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div> */}

                    </>
                )
            }



            <div className="fixed bottom-0 left-0 right-0 lg:right-auto lg:w-1/4 bg-white z-10 p-4 lg:p-6 border-t border-gray-200 shadow-sm">
                <div className="flex items-center gap-3">
                    <div className="flex flex-col mr-2">
                        <div className="flex items-center border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 bg-white hover:border-[#4B3BFF] overflow-hidden h-10">
                            <button
                                onClick={() => setNumberOfImages(Math.max(1, parseInt(numberOfImages) - 1))}
                                className="px-1 h-full text-gray-600 hover:text-[#4B3BFF] hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
                            >
                                <FontAwesomeIcon icon={faMinus} className="text-xs" />
                            </button>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[1-4]"
                                value={numberOfImages}
                                onChange={(e) => {
                                    const val = parseInt(e.target.value);
                                    if (!isNaN(val) && val >= 1 && val <= 4) {
                                        setNumberOfImages(val);
                                    }
                                }}
                                className="w-8 text-center h-full text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#4B3BFF] focus:border-transparent appearance-none font-medium"
                                style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                            />
                            <button
                                onClick={() => setNumberOfImages(Math.min(4, parseInt(numberOfImages) + 1))}
                                className="px-1 h-full text-gray-600 hover:text-purple-600 hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
                            >
                                <FontAwesomeIcon icon={faPlus} className="text-xs" />
                            </button>
                        </div>
                        {/* <label className="block text-gray-700 font-semibold mb-2 text-xs tracking-wide text-center">no. of Img's</label> */}
                    </div>
                    {/* <button
                        onClick={handleGenerate}
                        disabled={editEstTime > 0}
                        className={`flex-1 bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold py-2 lg:py-3 px-4 lg:px-6 rounded-lg shadow-lg transition-all duration-300 text-sm lg:text-base relative overflow-hidden ${editEstTime > 0
                            ? 'opacity-90 cursor-not-allowed'
                            : 'hover:shadow-xl hover:scale-[1.02] hover:from-purple-600 hover:to-indigo-600 active:scale-95'
                            }`}
                    >
                        {editEstTime > 0 && (
                            <div
                                className="absolute left-0 top-0 h-full bg-gradient-to-r from-purple-600 to-indigo-600 transition-all duration-300"
                                style={{ width: `${Math.max(0, Math.min(100, (editEstTime - progressEdit) / editEstTime * 100))}%`, opacity: 0.5 }}
                            ></div>
                        )}
                        <span className="relative z-10">
                            {editEstTime > 0
                                ? `Processing: ${Math.round((editEstTime - progressEdit) / editEstTime * 100)}%`
                                : "Generate"}
                        </span>
                    </button> */}
                    <button
                        onClick={handleGenerate}
                        disabled={loadingCircle}
                        className={`flex-1 bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold py-2 lg:py-3 px-4 lg:px-6 rounded-lg shadow-lg transition-all duration-300 text-sm lg:text-base relative overflow-hidden ${loadingCircle ? 'opacity-90 cursor-not-allowed' : 'hover:shadow-xl hover:scale-[1.02] hover:from-purple-600 hover:to-indigo-600 active:scale-95'}`}
                    >
                        <span className="relative z-10 flex items-center justify-center">
                            {loadingCircle ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Generating...
                                </>
                            ) : (
                                "Generate"
                            )}
                        </span>
                    </button>
                </div>
            </div>


            {isProductModalOpen && (
                <div className="fixed inset-0 z-50 flex justify-center items-center">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl transition-all duration-500"
                    ></div>
                    <div className="relative z-10 transform transition-all duration-500 ease-out"
                        style={{
                            opacity: isProductModalOpen ? 1 : 0,
                            transform: isProductModalOpen ? 'scale(1)' : 'scale(0.95)',
                            height: '80vh'
                        }}
                    >
                        <button
                            onClick={() => setIsProductModalOpen(false)}
                            className="absolute -top-4 -right-4 w-9 h-9 bg-white rounded-full shadow-lg flex items-center justify-center group hover:bg-[#4B3BFF] transition-all duration-300 transform hover:scale-110 hover:rotate-90"
                        >
                            <svg
                                className="w-5 h-5 text-gray-600 group-hover:text-gray-600 transition-colors duration-300"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                        <ProductGallery
                            setIsProductModalOpen={setIsProductModalOpen}
                            selectedSubProduct={selectedProduct}
                            handleProductSelect={handleProductSelect}
                            setRefNum={setRefNum}
                            setCreditsAvailable={setCreditsAvailable}
                        />
                    </div>
                </div>
            )}



        </div >
    );
};

export default EditSidebar;